import { ReactNode } from "react"
import { Link, useLocation } from "react-router"
import NCXLogo from "../images/NCX---Logo---Full---White.png"
import BirddogUserMenu from "./BirddogUserMenu"

export interface BirddogLayoutProps {
  children: ReactNode
}

const BirddogLayout = ({ children }: BirddogLayoutProps) => {
  const location = useLocation()
  const isDashboard =
    location.pathname === "/birddog" || location.pathname === "/birddog/"

  return (
    <div className="min-h-screen bg-gray-100">
      <header className="bg-charcoal-500 shadow-sm">
        <div className="px-5 mx-auto flex items-center justify-between h-16">
          <div className="flex items-center">
            <img className="h-8 w-auto mr-4" src={NCXLogo} alt="NCX Logo" />
            <h1 className="text-xl font-semibold text-white">BirdDog</h1>
          </div>
          <div className="flex items-center h-full">
            <nav className="flex h-full mr-6">
              <Link
                to="/birddog"
                className={`flex items-center justify-center text-base leading-[1.50] tracking-[0.02em] h-full font-semibold px-6 text-white transition-colors ${
                  isDashboard ? "border-b-4 border-white" : "hover:bg-[#3b3b39]"
                }`}
                style={isDashboard ? { backgroundColor: "#3b3b39" } : {}}
              >
                Dashboard
              </Link>
            </nav>
            <BirddogUserMenu />
          </div>
        </div>
      </header>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </div>
    </div>
  )
}

export default BirddogLayout
